import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/ConfirmationPage.module.css';
import { useOrder } from '../contexts/OrderContext';

const ConfirmationPage = () => {
  const navigate = useNavigate();
  const { clearOrder, order } = useOrder();
  const [orderReady, setOrderReady] = useState(false);

  const orderId = useMemo(
    () => 'MM-' + Math.floor(1000 + Math.random() * 9000),
    []
  );

  useEffect(() => {
    // clearOrder();

    if (order && order.finalTotal) {
      setOrderReady(true);
    }
  }, [order]);

  useEffect(() => {
    if (orderReady && window.fbq) {
      window.fbq('track', 'Purchase', {
        value: order.finalTotal,
        currency: 'USD',
        content_name: 'Custom Song Order',
        content_ids: [orderId],
        content_type: 'product',
      });
    } else if (orderReady && window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 0,
        currency: 'USD',
        content_name: 'Custom Song Order',
        content_ids: [orderId],
        content_type: 'product',
      });
    }
  }, [orderReady, order, orderId]);

  return (
    <div className={styles.container}>
      <div className={styles.confirmationCard}>
        <div className={styles.checkmark}>✓</div>
        <h1 className={styles.title}>Your Order is Confirmed!</h1>
        <p className={styles.orderNumber}>Order #{orderId}</p>
        <p className={styles.message}>
          Thank you for your order. We'll start working on your custom song right away.
        </p>
        <p className={styles.details}>
          You'll receive a confirmation email shortly with more details about your order.
        </p>
        <button
          className={styles.homeButton}
          onClick={() => navigate('/dashboard')}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default ConfirmationPage;